export const SIDEBAR_VISIBILITY_TOGGLE = 'SIDEBAR_VISIBILITY_TOGGLE';
export const SNACKBAR_TOGGLE = 'SNACKBAR_TOGGLE';
export const MODAL_TOGGLE = 'MODAL_TOGGLE';
